export default {
  state: {
    isLoading: true,
    container: 'full'
  },
  getters: {
    isLoading: state => state.isLoading,
    container: state => state.container,
    result: state => state.result // 临时登陆用  2018.1.28
  },
  mutations: {
    'SET_LOADING' (state, isLoading) {
      state.isLoading = isLoading
    },
    'SET_CONTAINER' (state, container) {
      if (container === 'palace') {
        document.body.style.background = '#eef5f9'
        document.body.style.position = 'absolute'
        document.body.style.width = '100%'
        document.body.style.height = '100%'
      } else {
        document.body.style.background = ''
      }
      state.container = container
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mixed/index.js